import { IConversationAuthClient, Restorable } from "@auvious/integrations";
import { AppConfigService } from "../../services";

export class NoAuthClient
  extends Restorable
  implements IConversationAuthClient
{
  authenticate() {
    return undefined;
  }
  getAuthCode() {
    return { applicationId: AppConfigService.applicationId };
  }
  async register() {
    return undefined;
  }
  async logout() {}
}
